import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Badge } from 'react-bootstrap';
import { getK3TaskLogs } from '../../actions'; // Assuming actions are exported from index

class K3TaskLogModal extends Component {
  constructor(props) {
    super(props);
    // Load settings from localStorage
    const savedSettings = JSON.parse(localStorage.getItem('k3TaskLogSettings') || '{}');
    console.log('savedSettings', savedSettings)
    this.state = {
      showLatestLogsFirst: savedSettings.showLatestLogsFirst || false,
      showSystemInfo: savedSettings.showSystemInfo || true,
      selectedLogLevel: savedSettings.selectedLogLevel || 100,
      autoUpdateLogs: savedSettings.autoUpdateLogs || false
    };
    this.refreshInterval = null;
  }

  componentDidMount() {
    console.log('K3TaskLogModal mounted');
    if (this.state.autoUpdateLogs) {
      this.startAutoRefresh();
    }
    setTimeout(() => {
      this.scrollToBottom();
    }, 3000);
    // this.props.getK3TaskLogs({ task_id: this.props.task._id });
    this.scrollToBottom();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.autoUpdateLogs) return;

    const nextLogs = nextProps.logsData[this.props.task._id]
    const currentLogs = this.props.logsData[this.props.task._id]

    if (!currentLogs || nextLogs.length > currentLogs.length) {
      setTimeout(() => {
        this.scrollToBottom();
      }, 1000);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      if (this.state.autoUpdateLogs) {
        this.startAutoRefresh();
      }
      this.scrollToBottom();
    } else if (!this.props.show && prevProps.show) {
      this.stopAutoRefresh();
    }
  }

  componentWillUnmount() {
    // Clean up interval when component unmounts
    this.stopAutoRefresh();
  }

  startAutoRefresh = () => {
    // Only start if not already running
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(() => {
        console.log('Refreshing logs');
        this.props.getK3TaskLogs({ task_id: this.props.task._id });
      }, 10000); // Refresh every 10 seconds
    }
  };

  stopAutoRefresh = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  };

  scrollToBottom = () => {
    const logContainer = document.querySelector('.log-container');
    if (logContainer) {
      logContainer.scrollTop = logContainer.scrollHeight;
    }
  };

  handleSettingChange = (key, value) => {
    this.setState({ [key]: value }, () => {
      // Save to localStorage whenever a setting changes
      const settings = {
        showLatestLogsFirst: this.state.showLatestLogsFirst,
        showSystemInfo: this.state.showSystemInfo,
        selectedLogLevel: this.state.selectedLogLevel,
        autoUpdateLogs: this.state.autoUpdateLogs
      };
      localStorage.setItem('k3TaskLogSettings', JSON.stringify(settings));

      // Handle auto-update toggle
      if (key === 'autoUpdateLogs') {
        if (value) {
          this.startAutoRefresh();
        } else {
          this.stopAutoRefresh();
        }
      }
    });
  };

  render() {
    const { show, onHide, task, logsData } = this.props;
    const { showLatestLogsFirst, showSystemInfo, selectedLogLevel, autoUpdateLogs } = this.state;

    if (!task) return null; // Don't render if no task is selected

    const logs = logsData[task._id] || [];

    const sortedLogs = [...logs]
      .filter(log => {
        if (!showSystemInfo && log.level >= 7) return false;
        if (log.level >= selectedLogLevel) return false;
        return true;
      })
      .sort((a, b) => {
        const timeA = new Date(a.time || a.createdAt);
        const timeB = new Date(b.time || b.createdAt);
        return showLatestLogsFirst ? timeB - timeA : timeA - timeB;
      });

    const getLevel1Style = (log) => {
      if (log.level === 1) {
        return {
          fontWeight: 'bold',
          color: log.type === 'error' ? '#ff0000' : '#00ff00' // Red for error, Green otherwise
        };
      }
      return {};
    };

    return (
      <Modal 
        show={show} 
        onHide={onHide} 
        size="xl" 
      >
        <Modal.Header closeButton>
          <Modal.Title>Task Logs - {task?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Task Info Badges - Add more relevant badges based on available data */}
          <div className="mb-2 d-flex flex-wrap">
            <Badge bg="danger" className="me-2 mb-1">Task ID: {task?._id}</Badge>
            <Badge bg="info" className="me-2 mb-1">Type: {task?.type}</Badge>
            <Badge bg="warning" className="me-2 mb-1">Status: {task?.status}</Badge>
            <Badge bg="secondary" className="me-2 mb-1">Created: {new Date(task?.createdAt).toLocaleString()}</Badge>
            <Badge bg="info" className="me-2 mb-1">Updated: {new Date(task?.updatedAt).toLocaleString()}</Badge>
          </div>
          <div 
            className="p-3 bg-dark text-white rounded log-container" 
            style={{ 
              maxHeight: '60vh', 
              overflowY: 'auto',
              fontFamily: 'monospace',
              fontSize: '14px'
            }}
          >
            {sortedLogs.map((log, index) => (
              <div 
                key={index} 
                className="mb-1" 
                style={getLevel1Style(log)}
              >
                {log.action_number && (
                  <span style={{
                    backgroundColor: log.action_number % 2 === 0 ? '#2196F3' : '#ffd700',
                    color: log.action_number % 2 === 0 ? '#fff' : '#000',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    marginRight: '8px',
                    fontWeight: 'bold'
                  }}>
                    #{log.action_number}
                  </span>
                )}
                [{new Date(log.time || log.createdAt).toLocaleString()}] {log.message}
              </div>
            ))}
            {logs.length === 0 && (
              <div className="text-center text-muted">
                No logs available for this task
              </div>
            )}
          </div>

          <div className="d-flex justify-content-end align-items-center mt-2">
            <div className="d-flex align-items-center gap-3">
              <Form.Check
                type="switch"
                id={`logModal-showLatestLogs-${task._id}`}
                label="Latest Log First"
                checked={showLatestLogsFirst}
                onChange={(e) => this.handleSettingChange('showLatestLogsFirst', e.target.checked)}
              />
              <Form.Check
                type="switch"
                id={`logModal-showSystemInfo-${task._id}`}
                label="System Info"
                checked={showSystemInfo}
                onChange={(e) => this.handleSettingChange('showSystemInfo', e.target.checked)}
              />
              <Form.Check
                type="switch"
                id={`logModal-autoUpdate-${task._id}`}
                label="Auto Update Logs"
                checked={autoUpdateLogs}
                onChange={(e) => this.handleSettingChange('autoUpdateLogs', e.target.checked)}
              />
              <Form.Select
                size="sm"
                style={{ width: '150px' }}
                value={selectedLogLevel}
                onChange={(e) => this.handleSettingChange('selectedLogLevel', parseInt(e.target.value))}
              >
                <option value="100">Show All Logs</option>
                <option value="2">Hide Level ≥ 2</option>
                <option value="3">Hide Level ≥ 3</option>
                <option value="4">Hide Level ≥ 4</option>
                <option value="5">Hide Level ≥ 5</option>
                <option value="6">Hide Level ≥ 6</option>
                <option value="7">Hide Level ≥ 7</option>
              </Form.Select>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  logsData: state.k3taskReducer.logs // Assuming logs are stored under k3taskReducer.logs keyed by taskId
});

const mapDispatchToProps = {
  getK3TaskLogs
};

export default connect(mapStateToProps, mapDispatchToProps)(K3TaskLogModal); 